import { Fragment, FC } from 'react'
import { Link } from 'react-router-dom'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import useAuthenStore from '../../../stores/authen/authenStore'
import { RoutesType } from '../../../router/routesConfig'
import useTranslate from '../../../i18n/useTranslate'

interface RenderMenuProps {
    handleSelectedMenu: (menuID: string) => void
    route: RoutesType
    index: number
    selectedMenu: string
}
const RenderMenu: FC<RenderMenuProps> = ({ handleSelectedMenu, route, index, selectedMenu }) => {
    const classes = useStyles()
    const authenStore = useAuthenStore()
    const translate = useTranslate()
    // const userGroupID = authenStore.profile.userGroupId || 0
    const permission = authenStore.profile?.permission ?? []
    const display = route.isDisplayMenu
    // const allow = (route.allowAccessGroupID || []).indexOf(userGroupID) > -1
    let allow: boolean = false
    let name: any = ''
    permission.every((per) => {
        if (route?.functionID && route.functionID === per.functionID) {
            allow = true
            name = translate.languageStore.currentLanguage == 'th' ? per.functionName_th : per.functionName_en
            return false //break
        }
        return true //continue
    })

    const isSelectedMenu = route.menuID === selectedMenu

    if (display && allow) {
        return (
            <Fragment key={route.menuID}>
                <List
                    classes={
                        isSelectedMenu
                            ? {
                                  root: clsx(classes.selectedMenu, classes.listRoot),
                              }
                            : { root: classes.listRoot }
                    }
                >
                    <ListItem
                        button
                        key={index}
                        component={Link}
                        to={route.path}
                        selected={isSelectedMenu}
                        onClick={() => {
                            handleSelectedMenu(route.menuID)
                        }}
                    >
                        <ListItemIcon
                            classes={
                                isSelectedMenu
                                    ? {
                                          root: clsx(classes.iconListRoot, classes.iconListSelectedRoot),
                                      }
                                    : { root: classes.iconListRoot }
                            }
                        >
                            {route.menuIcon}
                        </ListItemIcon>
                        <ListItemText
                            // primary={translate.get(route.menuLabelKey)}
                            primary={name}
                            className={classes.menuText}
                            disableTypography
                        />
                    </ListItem>
                </List>
            </Fragment>
        )
    } else {
        return null
    }
}

const useStyles = makeStyles((theme) => ({
    listRoot: {
        paddingBottom: 0,
        paddingTop: 0,
    },
    selectedMenu: {
        borderLeft: `4px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
    },
    menuText: {
        fontSize: '14px ',
    },
    iconListRoot: {
        minWidth: '40px',
    },
    iconListSelectedRoot: {
        color: theme.palette.primary.main,
    },
}))

export default RenderMenu
